import { LoaderShow, LoaderHide, copyOnClipboard, createAndOpenPanel, DateUtils, getLastVersion, openLastUpdatesWindow, checkForUpdates } from './utils';
import Switchery from 'switchery';
import * as ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'summernote/src/lang/summernote-it-IT';

window.select2AjaxDelay = 200;

toastr.options = {
	positionClass: 'toast-bottom-left',
};

window.needsConfirm = false;
let initialFormData = {};

window.editorjsTranslations = {
	/**
	 * @type {I18nDictionary}
	 */
	messages: {
		/**
		 * Other below: translation of different UI components of the editor.js core
		 */
		ui: {
			blockTunes: {
				toggler: {
					'Click to tune': 'Opzioni',
					'or drag to move': 'o trascina per spostare',
				},
			},
			inlineToolbar: {
				converter: {
					'Convert to': 'Converti in',
				},
			},
			toolbar: {
				toolbox: {
					Add: 'Aggiungi',
				},
			},
		},

		/**
		 * Section for translation Tool Names: both block and inline tools
		 */
		toolNames: {
			Text: 'Testo',
			Heading: 'Intestazione',
			Image: 'Immagine',
			List: 'Elenco',
			// Warning: 'Примечание',
			// Checklist: 'Elenco di controllo',
			Quote: 'Citazione',
			// Code: 'Codice',
			Gallery: 'Galleria',
			Delimiter: 'Separatore',
			'Raw HTML': 'HTML',
			Table: 'Tabella',
			Survey: 'Sondaggio',
			// Link: 'Link',
			// Marker: 'Marker',
			// Bold: 'Grassetto',
			// Italic: 'Corsivo',
			// InlineCode: 'Codice in linea',
			CdtEvent: 'Evento',
		},

		/**
		 * Section for passing translations to the external tools classes
		 */
		tools: {
			/**
			 * Each subsection is the i18n dictionary that will be passed to the corresponded plugin
			 * The name of a plugin should be equal the name you specify in the 'tool' section for that plugin
			 */
			// warning: {
			// 	// <-- 'Warning' tool will accept this dictionary section
			// 	Title: 'Title',
			// 	Message: 'Сообщение',
			// },

			/**
			 * Link is the internal Inline Tool
			 */
			// link: {
			// 	'Add a link': 'Aggiungi un link',
			// },
			/**
			 * The "stub" is an internal block tool, used to fit blocks that does not have the corresponded plugin
			 */
			stub: {
				'The block can not be displayed correctly.': 'Il componente non può essere visualizzato',
			},
		},

		/**
		 * Section allows to translate Block Tunes
		 */
		blockTunes: {
			/**
			 * Each subsection is the i18n dictionary that will be passed to the corresponded Block Tune plugin
			 * The name of a plugin should be equal the name you specify in the 'tunes' section for that plugin
			 *
			 * Also, there are few internal block tunes: "delete", "moveUp" and "moveDown"
			 */
			delete: {
				Delete: 'Elimina',
			},
			moveUp: {
				'Move up': 'Sposta sopra',
			},
			moveDown: {
				'Move down': 'Sposta sotto',
			},
		},
	},
};

$.extend(true, $.magnificPopup.defaults, {
	tClose: 'Chiudi (Esc)', // Alt text on close button
	tLoading: 'Caricamento in corso...', // Text that is displayed during loading. Can contain %curr% and %total% keys
	gallery: {
		tPrev: 'Precedente (Freccia sinistra)', // Alt text on left arrow
		tNext: 'Successivo (Freccia destra)', // Alt text on right arrow
		tCounter: '%curr% di %total%', // Markup for "1 of 7" counter
	},
	image: {
		tError: 'Immagine non caricata.', // Error message when image could not be loaded
	},
	ajax: {
		tError: 'Contenuto non caricato.', // Error message when ajax request failed
	},
});

function showLoaderOnUnload() {
	LoaderShow();
}
window.addEventListener('unload', showLoaderOnUnload);

function setConfirmPageLeave() {
	window.needsConfirm = true;
	window.addEventListener('beforeunload', askConfirmPageLeave);
}

function askConfirmPageLeave(e) {
	const confirmationMessage = 'Sei sicuro di voler uscire? Le modifiche non salvate andranno perse.';
	e.returnValue = confirmationMessage;
	return confirmationMessage;
}

window.clearConfirmPageLeave = function () {
	window.removeEventListener('beforeunload', askConfirmPageLeave);
};

// scatena i change dei campi form al keyup in modo da non dover levare il focus
let dispatchChangeTimeout = null;
$('#pageForm :input[id]:not(button):visible').on('keyup', function () {
	if (dispatchChangeTimeout) {
		clearTimeout();
	}

	dispatchChangeTimeout = setTimeout(() => {
		$(this).trigger('change');
		dispatchChangeTimeout = null;
	}, 500);
});

function validateFormFields() {
	const requiredFields = $('#pageForm :input[required]');
	let allFieldsValid = true;

	requiredFields.each(function () {
		if (!this.checkValidity()) {
			allFieldsValid = false;
			return false;
		}
	});

	if (allFieldsValid) {
		$('#save, #popupsave').prop('disabled', false);
		// $('#additional-contents .invalid-feedback').hide();
	} else {
		$('#save, #popupsave').prop('disabled', true);
		if ($('#save i').hasClass('fa-spinner')) $('#save i').toggleClass('fa-floppy-disk fa-spinner fa-spin');
		if ($('#popupsave i').hasClass('fa-spinner')) $('#popupsave i').toggleClass('fa-floppy-disk fa-spinner fa-spin');
		// $('#additional-contents .invalid-feedback').show();
	}
	return allFieldsValid;
}

window.formChangeHandler = async function formChangeHandler(evt, forced = false) {
	const allFieldsValid = validateFormFields();

	if (!forced && needsConfirm) return;

	// Check if any field has changed
	let formChanged = forced;
	const $pageForm = $('#pageForm');
	$pageForm
		.find(':input[id]:not(button):visible, .switchery:not(#form-editing-mode):visible, #crop_updated, #editor_updated, #crop_caption')
		.each(function () {
			const input = $(this);
			let currentValue = undefined;
			// TODO: non mi piace ma non so come altro fare
			if (input.hasClass('switchery')) {
				currentValue = input.css('background-color') !== 'rgb(255, 255, 255)';
			} else if (['checkbox', 'radio'].includes(input.attr('type'))) {
				currentValue = $(`input:checked[name="${input.attr('name')}"]`)
					.map((_idx, el) => el.value)
					.toArray();
			} else {
				currentValue = input.val();
			}
			const id = input.attr('id');
			let initialValue = initialFormData[id];

			if (Array.isArray(currentValue)) {
				currentValue = JSON.stringify(currentValue);
			}

			if (currentValue !== initialValue) {
				formChanged = true;
				return false; // Break the loop
			}
		});

	// If form has changed, validate and set needsConfirm
	if (formChanged) {
		if (!window.needsConfirm) {
			setConfirmPageLeave();
		}

		// Validate the form
		await $pageForm.formValidation('validate');

		const $isValidationOk = $pageForm.data('formValidation').isValid();
		if ($isValidationOk && allFieldsValid) {
			$('#save, #popupsave').prop('disabled', false);
		} else {
			const errors = [];
			$pageForm
				.data('formValidation')
				.getInvalidFields()
				.each((_idx, element) => {
					errors.push(element.getAttribute('id') + ' - ' + element.validationMessage);
				});
			console.info('Form is not valid', errors);
			$('#save, #popupsave').prop('disabled', true);
		}
	}
};

/**
 * Counter for whatsapp messages not stamped
 */
let whatsappChecker = function () {
	if (appconfig.routes?.whatsapp?.stamps?.unstamped !== undefined) {
		$.ajax({ url: appconfig.routes.whatsapp.stamps.unstamped }).done(function (data) {
			if (data.status === 'ok') {
				if (data.data > 0) {
					$('#whatsapp-counter').html(data.data);
				} else {
					$('#whatsapp-counter').html('');
				}
			}
		});
	}
};

$(function () {
	$('#openMenuForMobile').on('click', function () {
		if ($('body').hasClass('site-menubar-hide')) {
			$('body').removeClass('site-menubar-hide').addClass('site-menubar-unfold');
		} else {
			$('body').removeClass('site-menubar-unfold').addClass('site-menubar-hide');
		}
	});

	/**
	 * Auto Invokation and timout each 5 secs only for admins who aceed whastapp messages
	 */
	if (typeof authconfig !== 'undefined' && authconfig.user.admin) {
		setInterval(function () {
			whatsappChecker();
		}, 60000);
		whatsappChecker();
	}

	$('[rel=tooltip]').tooltip({ boundary: 'window' });
	$('[rel=tooltip-offset]').tooltip({ boundary: 'window', offset: '0, 13' });

	// CONFIGURAZIONE CAMPI FORMS

	if ($('.field-configurator').length) {
		$('.field-configurator').on('click', function () {
			const fieldName = $(this).attr('data-field-identifier');
			const fieldConfigs = FormConfigs.find((field) => field.identifier === fieldName);
			if (!fieldConfigs) return;

			if (fieldConfigs.type === 'select') {
				fieldConfigs.attrs = Object.assign({ multiple: false, 'data-close-on-select': true }, fieldConfigs.attrs);
			} else if (fieldConfigs.type === 'number') {
				fieldConfigs.attrs = Object.assign({ min: 1, step: 1 }, fieldConfigs.attrs);
			} else if (fieldConfigs.type === 'text') {
				fieldConfigs.attrs = Object.assign({ 'data-seo-max': null, 'data-seo-min': null }, fieldConfigs.attrs);
			}

			$.magnificPopup.open(
				{
					items: {
						src: $('#popup'),
					},
					type: 'inline',
					closeOnBgClick: false,
					callbacks: {
						close: function () {
							const container = $('#popup-content');
							container.empty();
						},
						open: function () {
							const container = $('#popup-content');
							container.empty();

							const form = `
								<h3 class="text-center">Configurazione campo form</h3>
								<form id="editor-configs-form" class="p-4">
									<input required readonly disabled type="hidden" name="config_id" id="config_id" value="${fieldConfigs.id}" />
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_page">Pagina</label>
										</h4>
										<div class="col-sm-9">
											<input required readonly disabled name="config_page" id="config_page" class="form-control" value="${fieldConfigs.page}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_group">Gruppo</label>
										</h4>
										<div class="col-sm-9">
											<input name="config_group" id="config_group" class="form-control" value="${fieldConfigs.group ?? ''}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_identifier">Campo</label>
										</h4>
										<div class="col-sm-9">
											<input required readonly disabled name="config_identifier" id="config_identifier" class="form-control" value="${fieldConfigs.identifier}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_type">Tipo</label>
										</h4>
										<div class="col-sm-9">
											<select required id="config_type" name="config_type" class="form-control">
												<option value="text" ${fieldConfigs.type === 'text' ? 'selected' : ''}>Text</option>
												<option value="select" ${fieldConfigs.type === 'select' ? 'selected' : ''}>Select</option>
												<option value="boolean" ${fieldConfigs.type === 'boolean' ? 'selected' : ''}>Boolean</option>
												<option value="switch" ${fieldConfigs.type === 'switch' ? 'selected' : ''}>Switch</option>
												<option value="checkbox" ${fieldConfigs.type === 'checkbox' ? 'selected' : ''}>Checkbox</option>
												<option value="password" ${fieldConfigs.type === 'password' ? 'selected' : ''}>Password</option>
												<option value="textarea" ${fieldConfigs.type === 'textarea' ? 'selected' : ''}>Textarea</option>
												<option value="date" ${fieldConfigs.type === 'date' ? 'selected' : ''}>Date</option>
												<option value="datetime" ${fieldConfigs.type === 'datetime' ? 'selected' : ''}>Datetime</option>
												<option value="editor" ${fieldConfigs.type === 'editor' ? 'selected' : ''}>Editor</option>
												<option value="url" ${fieldConfigs.type === 'url' ? 'selected' : ''}>Url</option>
												<option value="cover_advanced" ${fieldConfigs.type === 'cover_advanced' ? 'selected' : ''}>Cover Advanced</option>
											</select>
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_label">Etichetta</label>
										</h4>
										<div class="col-sm-9">
											<input required name="config_label" id="config_label" class="form-control" value="${fieldConfigs.label}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_enabled">Abilitato</label>
										</h4>
										<div class="col-sm-9">
											<select id="config_enabled" name="config_enabled" class="form-control">
												<option value="true" ${fieldConfigs.enabled ? 'selected' : ''}>S&igrave;</option>
												<option value="false" ${!fieldConfigs.enabled ? 'selected' : ''}>No</option>
											</select>
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_required">Obbligatorio</label>
										</h4>
										<div class="col-sm-9">
											<select id="config_required" name="config_required" class="form-control">
												<option value="true" ${fieldConfigs.required ? 'selected' : ''}>S&igrave;</option>
												<option value="false" ${!fieldConfigs.required ? 'selected' : ''}>No</option>
											</select>
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_crud_route">Abilita pulsanti Crud</label>
										</h4>
										<div class="col-sm-9">
											<input name="config_crud_route" placeholder="Inserire nome endpoint" ${
												fieldConfigs.type !== 'select' ? 'readonly disabled' : ''
											} id="config_crud_route" class="form-control" value="${fieldConfigs.crud_route}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_css_classes">Classi css</label>
										</h4>
										<div class="col-sm-9">
											<input name="config_css_classes" id="config_css_classes" class="form-control" value="${fieldConfigs.css_classes}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_placeholder">Placeholder</label>
										</h4>
										<div class="col-sm-9">
											<input name="config_placeholder" id="config_placeholder" class="form-control" value="${fieldConfigs.placeholder}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_info">Tooltip</label>
										</h4>
										<div class="col-sm-9">
											<input name="config_info" id="config_info" class="form-control" value="${fieldConfigs.info}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_order">Ordinamento</label>
										</h4>
										<div class="col-sm-9">
											<input required type="number" step="1" name="config_order" id="config_order" class="form-control" value="${fieldConfigs.order}" />
										</div>
									</div>
									<div class="form-group row">
										<h4 class="example-title col-sm-3 mb-0">
											<label for="config_attributes">Attributi html</label>
										</h4>
										<div class="col-sm-9">
											<textarea class="ace_text-input" autocorrect="off" autocapitalize="none" spellcheck="false" wrap="off"></textarea>
											<div id="config_attributes" style="width:100%;height: 100%;min-height:200px"></div>
										</div>
									</div>
									<button type="button" id="editor-configs-form-submit" class="btn btn-primary w-full">Salva</button>
								</form>
							`;
							container.html(form);

							let fleditor = ace.edit('config_attributes');
							let textarea = $('#config_attributes').siblings('textarea').first();

							fleditor.setTheme('ace/theme/github');
							fleditor.getSession().setMode('ace/mode/json');
							fleditor.getSession().setOptions({
								// theme: 'ace/theme/github',
								// mode: 'ace/mode/json',
								tabSize: 4,
								useSoftTabs: true,
							});
							fleditor.getSession().on('change', function () {
								textarea.val(fleditor.getSession().getValue());
							});
							const stringified = Array.isArray(fieldConfigs.attrs) ? '{}' : JSON.stringify(fieldConfigs.attrs, null, '\t');
							fleditor.setValue(stringified);
							textarea.val(stringified);
						},
					},
					midClick: true,
				},
				0,
			);
		});

		$(document).on('click', '#editor-configs-form-submit', function () {
			var json = {
				id: parseInt($('#config_id').val()),
				identifier: $('#config_identifier').val(),
				type: $('#config_type').val(),
				label: $('#config_label').val(),
				enabled: $('#config_enabled').val() === 'true',
				required: $('#config_required').val() === 'true',
				crud_route: $('#config_crud_route').val(),
				css_classes: $('#config_css_classes').val(),
				placeholder: $('#config_placeholder').val(),
				info: $('#config_info').val(),
				order: parseInt($('#config_order').val() || '0'),
				attrs: JSON.parse($('#config_attributes').siblings('textarea').first().val() || '{}'),
			};

			const fieldIdx = FormConfigs.findIndex((field) => field.id === json.id);
			if (fieldIdx === -1) return;

			$.ajax({
				type: 'POST',
				url: appconfig.routes.form.edit + '?editing=true',
				data: JSON.stringify(json),
				success: function (data) {
					location.reload();
				},
				error: function (jqXHR) {
					const errorMessage = JSON.parse(jqXHR.responseText).message || 'Si è verificato un errore inatteso, contattare il dipartimento IT';
					toastr.error(errorMessage);
				},
				contentType: 'application/json',
				dataType: 'json',
			});
		});
	}

	// GESTIONE COMUNE CAMPI FORMS DI TIPO DATA
	$('[data-no-date]').on('click', function () {
		const field = document.getElementById(this.getAttribute('data-field-identifier'));
		DateUtils.getFlatPickr(field).clear();
	});
	$('[data-current-date]').on('click', function () {
		const field = document.getElementById(this.getAttribute('data-field-identifier'));
		DateUtils.timeSync(field);
	});
	$('[data-inputmask]').each((idx, el) => {
		DateUtils.getFlatPickr(el);
	});

	// gestione campi con proprietà max/min
	const seocheker = {
		init: function () {
			$('input[data-seo-max]').each(function (index, e) {
				seocheker.trig(e);
				$(e).keyup((e) => seocheker.trig(e.currentTarget));
			});
		},

		trig: function (e) {
			const fieldContainer = $(e).closest('.panel-body');
			let seocurrent = fieldContainer.find('.seo-current');
			let seodelta = fieldContainer.find('.seo-delta');

			let current = e.value.length;

			seocurrent.text(current);

			if (current < $(e).data('seo-min')) {
				seodelta.text(current - $(e).data('seo-min'));
				seodelta.addClass('text-danger');
			} else if (current > $(e).data('seo-max')) {
				seodelta.text('+' + (current - $(e).data('seo-max')));
				seodelta.addClass('text-danger');
			} else {
				seodelta.removeClass('text-danger').addClass('text-success');
				seodelta.text('OK');
			}
		},
	};
	seocheker.init();

	// // inizializzazione comportamenti campi select2
	$('select')
		.on('select2:select', function (evt) {
			$(this).parent().find('.select2-search__field').val('');
		})
		.on('select2:unselect', function (evt) {
			if (evt.params.originalEvent) {
				const choiceId = evt.params.originalEvent.currentTarget.getAttribute('data-select2-id');
				$(`#select2-${evt.currentTarget.id}-results .select2-results__option[data-select2-id="${choiceId}"]`)
					.removeClass('select2-results__option--selected')
					.attr('aria-selected', 'false');
			}
		});

	$('select[data-ajax="true"]').on('select2:unselect', function (evt) {
		$('#' + evt.currentTarget.id + " option[value='" + evt.params.data.id + "']").remove();
	});

	// gestione campi copia valore
	$(document).on('click', '[data-copy]', function (e) {
		e.preventDefault();
		e.stopPropagation();
		copyOnClipboard(this);

		return false;
	});

	$(document).on('click', '[data-download]', function (e) {
		e.preventDefault();
		e.stopPropagation();
		const url = $(e.currentTarget).attr('data-download');
		if (!url.length) return false;

		clearConfirmPageLeave();
		location.href = appconfig.routes.files.download + '?url=' + encodeURIComponent(url);
		if (window.needsConfirm) {
			setConfirmPageLeave();
		}

		return false;
	});

	// inizializzazione campi switch
	const elems = document.querySelectorAll('input[data-plugin="switchery"], input[data-switchery]');
	for (let i = 0; i < elems.length; i++) {
		const elem = elems[i];
		const size = elem.getAttribute('data-size') || 'default';
		new Switchery(elem, {
			size: size,
			color: 'var(--primary)',
			secondaryColor: 'var(--gray)',
		});
	}

	// inizializzazione campi editor summernote
	window.summernoteEditor = $('textarea[data-plugin="summernote"]').each(function (_idx, elem) {
		const $element = $(elem);
		const maxLength = $element.attr('data-seo-max');
		const summernoteOptions =
			window.summernoteOptions !== undefined
				? window.customSummernoteOptions.buttons !== undefined || window.customSummernoteOptions.toolbar !== undefined
					? window.customSummernoteOptions
					: window.customSummernoteOptions[$element.attr('id')]
				: {
						height: 150,
						toolbar: [
							['style', ['bold', 'italic', 'underline']],
							['para', ['ul', 'paragraph']],
							['insert', ['link', 'hr']],
						],
						popover: {
							image: [['remove', ['removeMedia']]],
						},
					};
		const options = Object.assign(summernoteOptions, {
			lang: 'it-IT',
			callbacks: {
				onDialogShown: function () {
					// Check if the dialog is the link dialog
					console.log('aperto');
					const linkDialog = $('.modal.note-modal.link-dialog.show');

					// If the link dialog is found
					if (linkDialog.length) {
						// Locate the checkbox div and uncheck/hide the checkbox
						const protocolCheckboxDiv = linkDialog.find('.checkbox.sn-checkbox-use-protocol');
						const protocolCheckbox = protocolCheckboxDiv.find('input[type="checkbox"]');

						// Uncheck the checkbox and hide the whole div
						protocolCheckbox.prop('checked', false).removeAttr('checked');
						protocolCheckbox.attr('aria-checked', 'false'); // Update the aria-checked attribute as well
						protocolCheckboxDiv.hide();

						// Clear the interval once we've made the modification
					}
				},
			},
		});

		if (maxLength) {
			options.callbacks.onKeydown = function (e) {
				var t = e.currentTarget.innerText;
				if (t.length >= maxLength && e.keyCode != 8) e.preventDefault();
			};
			options.callbacks.onKeyup = function (e) {
				var t = e.currentTarget.innerText;
				if (typeof callbackMax == 'function') {
					callbackMax(maxLength - t.length);
				}
			};
			options.callbacks.onPaste = function (e) {
				var t = e.currentTarget.innerText;
				var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
				e.preventDefault();
				var all = t + bufferText;
				document.execCommand('insertText', false, all.trim().substring(0, maxLength));
				if (typeof callbackMax == 'function') {
					callbackMax(maxLength - t.length);
				}
			};
		}

		$element
			.summernote(options)
			.on('summernote.paste', function (_e, ne) {
				var bufferText = ((ne.originalEvent || ne).clipboardData || window.clipboardData).getData('Text');
				ne.preventDefault();
				document.execCommand('insertText', false, bufferText);
			})
			.on('summernote.change', formChangeHandler);
	});

	// initializzazione bottone dettaglio tabelle

	// Controllo chiusura popup
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.get('popup') === 'true' || window.self !== window.top) {
		window.addEventListener('message', function (event) {
			if (event.data === 'requestClose') {
				if (window.needsConfirm) {
					window.parent.postMessage('preventClose', '*');
					console.warn('prevent close');
				} else {
					const unlock = $('#unlockurl');
					if (unlock.length) {
						window.Utils.LoaderShow();
						if (window.pollingInterval) {
							clearInterval(window.pollingInterval);
							pollingInterval = null;
							if (window.pollingCall) {
								window.pollingCall.abort("Annullato dall'utente");
								window.pollingCall = null;
							}
						}
						$.ajax(unlock.val()).then(() => {
							window.parent.postMessage('allowClose', '*');
							console.info('allow close');
						});
					} else {
						window.parent.postMessage('allowClose', '*');
						console.info('allow close');
					}
				}
			} else if (event.data === 'pong') {
				window.dispatchEvent(new Event('handshakeDone'));
			} else if (event.data === 'changelogUpdated') {
				console.info('changelog updated');
				checkForUpdates();
			} else if (event.data.action === 'setNeedsConfirm') {
				window.needsConfirm = event.data.value;
			}
		});

		window.parent.postMessage('ping', '*');
		console.info('Inizializzato protocollo risposta a requestClose');
	}

	// GESTIONE COMUNE MODIFICA FORM E CONFERMA CAMBIO PAGINA
	const pageForm = $('#pageForm');
	if (pageForm.length) {
		// finchè non cambio qualcosa il plsante salva è spento
		$('#save, #popupsave').prop('disabled', true);

		pageForm.on('change', formChangeHandler);
		$('.switchery:not(#form-editing-mode)').on('click', formChangeHandler);

		$('button[type="submit"]').on('click', function (e) {
			const $btn = $(this);
			// Se il pulsante ha già la classe 'submitting', blocca il click
			if ($btn.hasClass('submitting')) {
				e.preventDefault();
				return false;
			}
			clearConfirmPageLeave();

			const backButton = $('#close');
			if (!window.needsConfirm && backButton.length) {
				if (backButton.attr('href')) {
					window.location.href = backButton.attr('href');
				} else {
					backButton.trigger('click');
				}
				return false;
			} else {
				$btn.addClass('submitting');
				if (!$('#save i').hasClass('fa-spinner')) $('#save i').toggleClass('fa-floppy-disk fa-spinner fa-spin');
				if (!$('#popupsave i').hasClass('fa-spinner')) $('#popupsave i').toggleClass('fa-floppy-disk fa-spinner fa-spin');
				$btn.css({
					cursor: 'not-allowed',
					opacity: '0.75',
				});
			}
		});

		// abilita la modalità di modifica del form
		$('#form-editing-mode.switchery').on('click', function () {
			pageForm.toggleClass('editing-mode');
		});
	}

	// Capture initial form values
	$('#pageForm')
		.find(':input[id]:not(button)')
		.each(function () {
			const input = $(this);
			let value = input.val();
			if (Array.isArray(value)) {
				value = JSON.stringify(value);
			}
			initialFormData[input.attr('id')] = value;
		});

	// inietta il flag popup nell'url se è un redirect interno ad un iframe
	if (window.self !== window.top) {
		$('a[href]').each((_idx, el) => {
			const href = el.getAttribute('href');
			if (!href.includes('popup=true')) {
				el.setAttribute('href', href + (el.href.includes('?') ? '&' : '?') + 'popup=true');
			}
		});
	}

	window.addEventListener(
		'message',
		function (event) {
			if (event.origin != this.location.origin) {
				return;
			}
			switch (event.data) {
				case 'closeup':
					$('#panel #close-popup').trigger('click');
					break;
			}
		},
		false,
	);

	$('#impersonate').select2({
		allowClear: false,
		multiple: false,
		width: '100%',
		ajax: {
			delay: window.select2AjaxDelay,
			url: appconfig.routes.journalists.impersonate,
			dataType: 'json',
			data: function (params) {
				return { q: params.term, page: params.page || 1 };
			},
			processResults: function (data) {
				let list = data.data || data;
				return {
					results: $.map(list.results, function (obj) {
						return { id: obj.id, text: obj.name };
					}),
					pagination: list.pagination,
				};
			},
		},
	});

	let userFiltersChanged = false;
	if ($('#filtersForm').length) {
		$('#filtersForm').on('change', function () {
			userFiltersChanged = true;
		});

		window.addEventListener('keyup', function (e) {
			if (e.key === 'Enter' && userFiltersChanged) {
				$('#filtersForm').submit();
			}
		});
	}

	$('button[data-current-date]').each(function () {
		const field = $('#' + $(this).attr('data-field-identifier'));
		const clock = $(this).find('i')[0];
		DateUtils.replaceClockIcon(clock, field.val().split(' al ')[0]);
		// splitto nel caso dei date range di datepickr
		field.on('change', () => DateUtils.replaceClockIcon(clock, field.val().split(' al ')[0]));
	});

	$('.popup-preview-image').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: function (item) {
				return item.el.attr('title') ?? '';
			},
		},
		zoom: {
			enabled: true,
		},
		gallery: {
			enabled: true,
		},
	});

	$('.popup-preview-gallery').each(function () {
		$(this).magnificPopup({
			delegate: '.popup-preview-gallery-image',
			type: 'image',
			closeOnContentClick: true,
			closeBtnInside: false,
			mainClass: 'mfp-with-zoom mfp-img-mobile',
			image: {
				verticalFit: true,
				titleSrc: function (item) {
					return item.el.attr('title') ?? '';
				},
			},
			zoom: {
				enabled: true,
			},
			gallery: {
				enabled: true,
			},
		});
	});

	setTimeout(() => {
		$('#save,#popupsave').prop('disabled', true);
	}, 1000);

	// TODO: implementare
	// $('.popup-preview-video').each(function () {
	// 	$(this).magnificPopup({
	// 		iframe: {
	// 			markup:
	// 				'<div class="mfp-iframe-scaler">' +
	// 				'<div class="mfp-close"></div>' +
	// 				'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
	// 				'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

	// 			patterns: {
	// 				youtube: {
	// 					index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

	// 					id: 'v=', // String that splits URL in a two parts, second part should be %id%
	// 					// Or null - full URL will be returned
	// 					// Or a function that should return %id%, for example:
	// 					// id: function(url) { return 'parsed id'; }

	// 					src: '//www.youtube.com/embed/%id%?autoplay=1', // URL that will be set as a source for iframe.
	// 				},
	// 				vimeo: {
	// 					index: 'vimeo.com/',
	// 					id: '/',
	// 					src: '//player.vimeo.com/video/%id%?autoplay=1',
	// 				},
	// 				gmaps: {
	// 					index: '//maps.google.',
	// 					src: '%id%&output=embed',
	// 				},

	// 				// you may add here more sources
	// 			},

	// 			srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
	// 		},
	// 	});
	// });

	$(document).on('click', '.timeline-item a', function () {
		const id = $(this).parent('li').attr('data-id');
		if (!id) return;

		if ($('[data-toggle="offcanvas"][data-id="' + id + '"]').length) {
			console.log('found element, triggering show details');
			$('[data-toggle="offcanvas"][data-id="' + id + '"]').trigger('click');
			$('.offcanvas-body').animate({ scrollTop: 0 });
		} else {
			console.log('no element found, redirecting to correct page');
			const url = new URL(window.location.origin + window.location.pathname);
			url.searchParams.set('q', '#' + id);
			url.searchParams.set('period', 'epoch');
			window.location.href = url.toString();
		}
	});

	checkForUpdates();
});

window.Utils = {
	LoaderShow: LoaderShow,
	LoaderHide: LoaderHide,
	createAndOpenPanel: createAndOpenPanel,
	openLastUpdatesWindow: openLastUpdatesWindow,
	copyOnClipboard: copyOnClipboard,
};
